import PortalVue from 'portal-vue'
import VueMeta from 'vue-meta'
import { GridPlugin } from '@syncfusion/ej2-vue-grids'
import RouterLink from '@/modules/common/core/component/RouterLink.vue'
import dayjs from 'dayjs'
import relativeTime from 'dayjs/plugin/relativeTime'
import jalaliday from 'jalaliday'
import { BootFileParams } from '@niknevis/vue-modules/types'
import Component from '@niknevis/vue-modules/vue-class-component'

export default function({ Vue }: BootFileParams) {
  Vue.use(PortalVue)
  Vue.use(VueMeta)
  Vue.use(GridPlugin)
  Vue.component('router-link', RouterLink)
  dayjs.extend(relativeTime)
  dayjs.extend(jalaliday)
  // @ts-ignore
  dayjs.calendar('jalali')
  dayjs.locale('fa')


  Component.registerHooks([
    'beforeRouteEnter',
    'metaInfo'
  ])
}
